import { Trans, useTranslation } from "react-i18next";
import LangLink from "../Localization/LangLink";
import { useMatches } from "react-router-dom";
import React from "react";

const useNamespace = (namespace = "main") => {
    const matches = useMatches();

    const routeNamespaces = matches
        .flatMap(m => {
            const ns = m.handle?.namespace;
            return Array.isArray(ns) ? ns : ns ? [ns] : [];
        });

    const baseNamespaces = Array.isArray(namespace)
        ? namespace
        : [namespace];

    const finalNamespaces = [...new Set([
        ...routeNamespaces,
        ...baseNamespaces
    ])];

    return getNamespaces(finalNamespaces);
};

function normalizeKey(layerName) {
    if (/^\d+$/.test(layerName)) {
        return layerName;
    }

    const parts = layerName.split("_");
    const last = parts[parts.length - 1];

    if (/^\d+$/.test(last)) {
        return last;
    }

    //console.warn("Translation key might be invalid", layerName);
    return layerName;
}

const getNamespaces = (namespaces = "main") => {
    const base = ["default"];

    if (typeof namespaces === "string") {
        return [namespaces, ...base];
    }

    if (Array.isArray(namespaces)) {
        return [...namespaces, ...base];
    }

    return base;
};

const Nbsp = () => <>&nbsp;</>;

export const Txt = ({
    id,
    value,
    links = [],
    color,
    components = {},
    namespace = 'main',
    ignoreComps = false,
    target = "_blank",
    baseOnClick = (e) => {
        e?.stopPropagation();
    },
    boldValue = false,
    linkStyle = {},
}) => {
    const nss = useNamespace(namespace);
    const { t } = useTranslation(nss);

    if (!id || id.trim() === "") {
        console.error("TEXT WITH NO ID!");
        return null;
    }

    const normalized = normalizeKey(id);

    const linkComponents = {
        ...(Array.isArray(links)
            ? links.length === 1
                ? {
                    l: (
                        <LangLink
                            to={typeof links[0] === "string" ? links[0] : links[0].to}
                            target={target}
                            rel="noreferrer"
                            style={{
                                color: color || "#0165F4",
                                textDecoration: "none",
                                ...linkStyle,
                            }}
                            onClick={typeof links[0] === "object" ? links[0]?.onClick : baseOnClick}
                        />
                    ),
                }
                : Object.fromEntries(
                    links.map((link, i) => [
                        `l${i}`,
                        <LangLink
                            key={`l${i}`}
                            to={typeof link === "string" ? link : link.to}
                            onClick={typeof link === "object" ? link?.onClick : baseOnClick}
                            target={target}
                            rel="noreferrer"
                            style={{
                                color: color || "#0165F4",
                                textDecoration: "none",
                                ...linkStyle,
                            }}
                        />,
                    ])
                )
            : {}),
    };

    const transComponents = {
        b: <b />,
        br: <br />,
        c: <span style={{ color: color || "#4534C2" }} />,
        u: <Nbsp />,
        ...linkComponents,
        ...components,
    };

    if (boldValue) {
        const text = t(normalized, { value });
        const parts = text.split(value);

        return (
            <>
                {parts.map((part, i) => (
                    <React.Fragment key={i}>
                        {part}
                        {i < parts.length - 1 && <b>{value}</b>}
                    </React.Fragment>
                ))}
            </>
        );
    }

    return (
        <Trans
            ns={nss}
            i18nKey={normalized}
            values={{ value }}
            components={transComponents}
        />
    );
};

export function useTxt(namespace = "main") {
    const nss = useNamespace(namespace);
    return useTranslation(nss).t;
}



